 export const administratorList = [
    {_id: "0", name: "General Admin"},
    {_id: "1", name: "Super Admin"}
  ]